<script>
export default {
  name: 'SocialYoutube',
  props: {
    url: String,
  },
};
</script>

<template>
  <a :href="url" target="_blank">
    <svg class="ico" style="margin-right: -3px"><use xlink:href="#ico-youtube"></use></svg>
  </a>
</template>

<style scoped lang="scss"></style>
